import { render, staticRenderFns } from "./HeaderProjectDetail.vue?vue&type=template&id=57312ad9&"
import script from "./HeaderProjectDetail.vue?vue&type=script&lang=js&"
export * from "./HeaderProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProjectDetail.vue?vue&type=style&index=0&id=57312ad9&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports